// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--1AXXX","footerNav":"Footer-module--footer-nav--m9poh"};